import { RootState } from "../../../../../store";

import { commitmentsDataForGranularSelector } from "../commitmentsDataForGranularSelector";

export const savingsPlansTotalCostSelector = (
  state: RootState,
): number | null => {
  const data = commitmentsDataForGranularSelector(state);

  return data?.totals?.total_spend ?? null;
};
